import AGGridColumn from "@/utils/UIConstants/AGGridColumns/AGGridColumn.ts";
import {ColDef, ICellRendererParams} from "ag-grid-community";
import CommonFieldIds from "@/utils/constants/CommonFieldIds.ts";
import NamaMainFileWidgetUtils from "@/utils/UIConstants/NamaMainFileWidgetUtils.ts";
import AGGridColumnTemplate from "@/utils/UIConstants/AGGridColumns/AGGridColumnTemplate.ts";
import PlaceUtils from "@/utils/common/PlaceUtils.ts";
import {ExtraDisplayColumnMethodOptions} from "@/utils/common/ListViewUtils.ts";
import NamaCommon from "@/utils/common/NamaCommon.ts";

export default class AGGridRefOrGenRefColumn extends AGGridColumn {
  constructor(column: namaTypes.ListScreenColumn, entityType: string) {
    super(column, entityType);
  }

  override createColDef(extraOptions: ExtraDisplayColumnMethodOptions): ColDef {
    let colDef = AGGridColumn.defaultColDef(this.column, this.entityType, extraOptions.layout);
    colDef.cellRenderer = this.cellRenderer(extraOptions.forSearcher);
    return colDef;
  }

  private cellRenderer(forSearcher?: boolean): any {
    return (params: ICellRendererParams) => {
      let ref = params.value;
      if (!ref || ref['empty'] === true)
        return '';
      if (NamaMainFileWidgetUtils.shouldShowImageOnHover(ref[CommonFieldIds.ENTITY_TYPE]))
        return NamaMainFileWidgetUtils.linkWithMainImage(AGGridRefOrGenRefColumn.nameOfRef(ref), ref);
      else
        return AGGridColumnTemplate.linkWithBGColorTemplate(AGGridRefOrGenRefColumn.nameOfRef(ref), PlaceUtils.linkToObject(ref),
          ref[CommonFieldIds.COLOR_CODE], forSearcher);
    }
  }

  //delete??
  public static nameOfRef(ref: Record<any, any>) {
    return NamaCommon.nameOfRef(ref)
  }
}
